var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconJoyMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-joy-mobile_svg__a",
  x1: 28,
  x2: 28,
  y1: 0,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4951EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4E06F2"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "url(#icon-joy-mobile_svg__a)",
  rx: 10.667
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.532 34.035c.02-.04.056-.071.097-.087 1.164-.558 2.156-2.255 3.182-6.631l.449-1.976a745 745 0 0 1 1.185-5.196c.942-4.202 4.182-3.585 5.2-3.206a.183.183 0 0 1 .112.217.2.2 0 0 1-.041.078c-.341.388-.744 1.357-1.293 3.666-.292 1.228-1.354 5.644-1.739 7.243-1.12 4.693-4.67 5.988-6.966 6.158a.18.18 0 0 1-.2-.137.18.18 0 0 1 .014-.13M44.712 21.539c1.412.455 1.394 1.973 1.186 2.951a16.4 16.4 0 0 1-1.735 4.372.18.18 0 0 1-.221.082.18.18 0 0 1-.115-.207 6.86 6.86 0 0 0-.886-4.568c-1.124-1.858.766-2.956 1.77-2.63M35.041 22.918c1.071-1.062 4.679-3.094 5.984 2.372.517 2.057.49 4.215-.076 6.26a12.2 12.2 0 0 1-3.155 5.39.186.186 0 0 1-.305-.179c1.044-3.96.394-13.44-2.337-13.53a.18.18 0 0 1-.154-.12.19.19 0 0 1 .043-.193M35.873 38.132a.18.18 0 0 1 .206.111.185.185 0 0 1-.073.224 4.37 4.37 0 0 1-2.81.862c-2.656-.12-2.766-2.233-1.987-3.224a3.04 3.04 0 0 1 1.606-.987.18.18 0 0 1 .159.064.18.18 0 0 1 .036.168c-.35 1.175.549 3.197 2.863 2.782"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M24.96 23.669a8.1 8.1 0 0 1 5.235-1.992c3.005 0 5.16 1.938 5.16 4.912a8.1 8.1 0 0 1-.762 3.165 8 8 0 0 1-1.946 2.6 7.77 7.77 0 0 1-5.134 1.965c-3.107 0-5.24-1.965-5.24-4.966a8.2 8.2 0 0 1 .774-3.116 8.1 8.1 0 0 1 1.912-2.568m3.124 9.493c1.637-.87 2.744-5.104 2.925-5.805.235-.813.939-5.702-1.407-4.55-1.578.794-2.653 4.778-2.903 5.707l-.027.098c-.297 1.179-.956 5.783 1.412 4.55",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.633 32.774a.18.18 0 0 0 .194.069.18.18 0 0 0 .133-.159c.044-.759.854-1.674 2.24-1.571.978.075 1.478-1.492.668-2.318-1-1.023-2.487-.62-3.235.446-1.036 1.479-.633 2.738 0 3.533"
})));
export { SvgIconJoyMobile as ReactComponent };